import { html, css } from 'lit';

import '../../../../packages/neb-lit-components/src/components/tables/neb-table';
import '../../../../packages/neb-lit-components/src/components/neb-pagination';
import Overlay from '../../../../packages/neb-lit-components/src/components/overlays/neb-overlay';
import { parseDate } from '../../../../packages/neb-utils/date-util';
import { MODE } from '../../../../packages/neb-utils/table';
import '../../../../packages/neb-lit-components/src/components/neb-popup-header';
import { CSS_SPACING } from '../../../styles';
import { getDataIntegrityQueryJobDetails } from '../api-clients/data-integrity';
import { formatMsToMinSec } from '../utils/date-util';

const DATE_TIME_FORMAT = 'YYYY-MM-DD   hh:mm:ss A';

const PAGE_SIZE = 50;

export const ELEMENTS = {
  header: {
    id: 'header',
    title: 'Data Integrity Query Job Details',
  },
  queryJobDetails: { id: 'query-job-details-table' },
  pagination: { id: 'pagination' },
};

const getTableConfig = () => [
  {
    key: 'tenant.name',
    label: 'Tenant Name',
    flex: css`1 0 0`,
  },
  {
    key: 'tenant.id',
    label: 'Tenant ID',
    flex: css`0 0 300px`,
  },
  {
    key: 'tenant.salesforceId',
    label: 'Salesforce ID',
    flex: css`0 0 150px`,
  },
  {
    key: 'tenant.salesforceStatus',
    label: 'Salesforce Status',
    flex: css`0 0 150px`,
  },
  {
    key: 'result.total',
    label: 'Records Affected',
    flex: css`0 0 150px`,
  },
  {
    key: 'executionTimeMs',
    label: 'Execution Time (minutes)',
    flex: css`0 0 200px`,
    formatter: value => formatMsToMinSec(value),
  },
];

class NebOverlayDataIntegrityQueryJobDetails extends Overlay {
  static get properties() {
    return {
      __queryJobDetails: Array,
      __currentPageIndex: Number,
      __pageCount: Number,
      __items: Array,
    };
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__queryJobDetails = { details: [] };
    this.__currentPageIndex = 0;
    this.__pageCount = 1;
    this.__items = [];

    this.model = {
      queryId: '',
      issueId: '',
      description: '',
      jobId: '',
    };
  }

  __initHandlers() {
    this.__handlers = {
      pageChanged: page => {
        this.__currentPageIndex = page;
        this.__loadItems();
      },
    };
  }

  __loadItems() {
    this.__items = this.__queryJobDetails.details.slice(
      this.__currentPageIndex * PAGE_SIZE,
      (this.__currentPageIndex + 1) * PAGE_SIZE,
    );
  }

  __getHeaderTitle() {
    return `${ELEMENTS.header.title}: ${this.model.issueId}
    "${this.model.description}"   Date: ${parseDate(
      this.__queryJobDetails.date,
    ).format(DATE_TIME_FORMAT)}`;
  }

  async __loadData(queryId, jobId) {
    this.__queryJobDetails = await getDataIntegrityQueryJobDetails(
      queryId,
      jobId,
    );

    this.__pageCount = Math.ceil(
      this.__queryJobDetails.details.length / PAGE_SIZE,
    );

    this.__loadItems();
  }

  async connectedCallback() {
    super.connectedCallback();

    if (this.model.queryId && this.model.jobId) {
      await this.__loadData(this.model.queryId, this.model.jobId);
    }
  }

  static get styles() {
    return [
      super.styles,
      css`
        .header {
          padding: ${CSS_SPACING};
        }

        .content {
          display: flex;
          width: 100%;
          flex-flow: column nowrap;
        }

        .main-content {
          display: flex;
          flex-direction: column;
          flex: 1 0 0;
          overflow: auto;
        }

        .pagination {
          display: flex;
          justify-content: flex-end;
          margin: ${CSS_SPACING};
          flex-shrink: 0;
        }
      `,
    ];
  }

  __renderPagination() {
    if (this.__queryJobDetails.details.length <= PAGE_SIZE) {
      return '';
    }

    return html`
      <div class="pagination">
        <neb-pagination
          id="${ELEMENTS.pagination.id}"
          .currentPage="${this.__currentPageIndex}"
          .onPageChanged="${this.__handlers.pageChanged}"
          .pageCount="${this.__pageCount}"
        ></neb-pagination>
      </div>
    `;
  }

  renderContent() {
    return html`
      <neb-popup-header
        id="${ELEMENTS.header.id}"
        class="header"
        title="${this.__getHeaderTitle()}"
        .onCancel="${this.handlers.dismiss}"
        showCancelButton
      ></neb-popup-header>
      <div class="main-content">
        <neb-table
          id="${ELEMENTS.queryJobDetails.id}"
          .config="${getTableConfig()}"
          .model="${this.__items}"
          .mode="${MODE.NONE}"
          showShadedRows
        ></neb-table>
        ${this.__renderPagination()}
      </div>
    `;
  }
}

customElements.define(
  'neb-overlay-data-integrity-query-job-details',
  NebOverlayDataIntegrityQueryJobDetails,
);
